import '@/fonts.css';
import '@/index.css';
import { StrictMode } from 'react';
import { hydrateRoot } from 'react-dom/client';
import Main from '@/Main';

import i18n from '@/i18n';

// The html lang attribute is set by the server
const htmlTag = document.querySelector('html');
const htmlTagLangAttr = htmlTag?.getAttribute('lang');
const lang = htmlTagLangAttr ? htmlTagLangAttr : 'de-CH';

(async () => {
  await i18n.changeLanguage(lang);
})();

hydrateRoot(
  document.getElementById('root') as HTMLElement,
  <StrictMode>
    <Main />
  </StrictMode>
);
